import { useContext } from 'react';
import { Context } from '../contexts/PldFinanceProvider';

const usePldFinance = () => {
  const { pldFinance } = useContext(Context);
  return pldFinance;
};

export default usePldFinance;
